import { createActionGroup, props } from '@ngrx/store';
import { File } from './file.reducer';

export const fileServiceActions = createActionGroup({
  source: 'DashboardStore FileService',
  events: {
    get: props<{ key: string }>(),
    getSuccess: props<{ file: File }>(),
    getFailure: props<{ error: Error }>(),

    list: props<{ keys: string[] }>(),
    listSuccess: props<{ files: File[] }>(),
    listFailure: props<{ error: Error }>(),
  },
});
